// React
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// Style
import "../../styles/menu/PaymentStyle.scss";
// Recoil
import { useRecoilValue } from "recoil";
import { orderState, requestState } from "../../atom/menu";

function OrderHistory() {
  // 주문내역 화면

  const navigate = useNavigate();
  // Recoil State
  const requestData = useRecoilValue(requestState);
  const orderData = useRecoilValue(orderState);
  // useState
  const categoryList = ["주문내역", "결제내역", "요청내역"];
  const [category, setCategory] = useState<string>("주문내역");

  // Function
  function calcTotalAmount() {
    if (orderData) {
      let amt = 0 as number;
      orderData?.orderData.reduce((acc, cur) => {
        amt = acc + cur.payment!.totalAmount;
        return amt;
      }, amt);
      let total = amt as number;
      return total;
    } else return 0;
  }

  function calcTotalEA() {
    if (orderData) {
      let ea = 0 as number;
      orderData.orderData.reduce((acc, cur) => {
        cur.orderData.reduce((pre, val) => {
          ea = pre + val.ea;
          return ea;
        }, ea);
        return acc + ea;
      }, ea);
      return ea;
    } else {
      return 0;
    }
  }
  function calcTotalUsePoint() {
    if (orderData) {
      let usepoint = 0 as number;
      orderData?.orderData.reduce((acc, cur) => {
        usepoint = acc + cur.payment!.usePoint;
        return usepoint;
      }, usepoint);
      return usepoint;
    } else {
      return 0;
    }
  }

  return (
    <div className='flex col' style={{ backgroundColor: "#EEE" }}>
      <div className='menu-list-common-header' style={{ padding: 0 }}>
        <div
          className='big-category-horizontal'
          style={{ gap: 32, paddingLeft: 32 }}
        >
          <div className='flex row align-items-center' style={{ gap: 32 }}>
            {categoryList.map((v, i) => {
              return v === category ? (
                <div
                  className='TO-button-2 relative pointer'
                  style={{
                    color: "#010101",
                  }}
                  key={i}
                  onClick={() => {
                    setCategory(v);
                  }}
                >
                  <div className='big-category-active-bedg-line'></div>
                  {v}
                </div>
              ) : (
                <div
                  className='TO-button-2 text-color-gray-6 pointer'
                  key={i}
                  onClick={() => {
                    setCategory(v);
                  }}
                >
                  {v}
                </div>
              );
            })}
          </div>
        </div>
        <div className='table-info'>
          <span className='TO-title-2-small'>1번 창가테이블</span>
          <span className='TO-title-5'>/1층</span>
        </div>
      </div>
      <div style={{ padding: "24px" }}>
        {category === "요청내역" ? (
          <div className='order-paper-wrap w-auto' style={{ height: 524 }}>
            <div
              className='order-row-history text-color-gray-5'
              style={{ padding: "4px 0", borderBottom: "1px solid #BFBFBF" }}
            >
              <div>No</div>
              <div>주문 시간</div>
              <div>메뉴</div>
              <div></div>
              <div>수량</div>
            </div>
            <div className='scroll' style={{ paddingTop: 16 }}>
              {requestData?.map((v, i) => {
                return (
                  <div className='order-menu-wrap'>
                    <div className='order-row-history'>
                      <div className='history-bell-btn'>
                        <img src={"/assets/images/menu/bell2.svg"} alt='bell' />
                        <span className='TO-option-2'>
                          {i + 1 > 9 ? i + 1 : "0" + (i + 1)}
                        </span>
                      </div>
                      <div className='MO-price-4 text-color-black-2'>
                        {i === 0 && "최근요청 "}
                        {v.time}
                      </div>
                      <div className='flex col'>
                        {v.request.map((val) => {
                          return (
                            <div className='flex row justify-content-between'>
                              <div className='TO-title-4 text-color-black-2 text-elipsis-2'>
                                {val.name}
                              </div>
                              <div className='TO-price-4 text-color-black-2'></div>
                              <div className='TO-price-4 text-color-black-2'>
                                {val.ea}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className='order-paper-wrap w-auto' style={{ height: 524 }}>
            <div
              className='order-row-history text-color-gray-5'
              style={{ padding: "4px 0", borderBottom: "1px solid #BFBFBF" }}
            >
              <div>No</div>
              <div>주문 시간</div>
              <div>메뉴</div>
              <div>수량</div>
              <div>개당 가격</div>
            </div>
            <div className='scroll' style={{ paddingTop: 16 }}>
              {orderData?.orderData?.map((v, i) => {
                return (
                  <div className='order-menu-wrap'>
                    <div className='order-row-history'>
                      <div
                        className='history-bill-btn'
                        style={{ paddingLeft: 10 }}
                      >
                        <img
                          src={"/assets/images/menu/bill.svg"}
                          alt='bill'
                          style={{ marginTop: 1 }}
                        />
                        <span className='TO-option-2' style={{ marginTop: 3 }}>
                          {i + 1 > 9 ? i + 1 : "0" + (i + 1)}
                        </span>
                      </div>
                      <div className='MO-price-4 text-color-black-2'>
                        {i === 0 && "최근주문 "} {v.orderTime}
                      </div>
                      <div className='flex col'>
                        {v.orderData.map((val) => {
                          return (
                            <>
                              <div className='history-contents'>
                                <div className='TO-title-4 text-color-black-2 text-elipsis-2'>
                                  {val.name}
                                </div>
                                <div className='TO-price-4 text-color-black-2'>
                                  {val.ea}
                                  <img
                                    src={"/assets/images/menu/star.svg"}
                                    alt='star'
                                  />
                                </div>
                                <div className='TO-price-4 text-color-black-2'>
                                  {val.price.toLocaleString()}
                                </div>
                              </div>
                              {val.option &&
                                val.option.map((option) => {
                                  return (
                                    <div className='history-contents text-color-gray-5'>
                                      <div className='TO-option-2'>
                                        {option.name} {option.ea},
                                      </div>
                                      <div className='TO-price-5'></div>
                                      <div className='TO-option-2'>
                                        {option.price.toLocaleString()}
                                      </div>
                                    </div>
                                  );
                                })}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className='flex col h-auto'>
              <div
                className='order-row TO-title-5'
                style={{
                  color: "#303030",
                  padding: "10px 0",
                  borderTop: "1px solid #BFBFBF",
                }}
              >
                <div>포인트 사용</div>
                <div></div>
                <div>-{calcTotalUsePoint()} P</div>
              </div>
              <div
                className='order-row TO-button-2'
                style={{ color: "#303030", marginTop: 20 }}
              >
                <div>합계</div>
                <div>{calcTotalEA()}</div>
                <div>{calcTotalAmount().toLocaleString()}</div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className='flex row'
        style={{ backgroundColor: "#F6F6F6", gap: 8, padding: "16px 24px" }}
      >
        <div
          className='basic-btn white TO-button-1 pointer'
          style={{ minWidth: "100%" }}
          onClick={() => {
            navigate("/menu");
          }}
        >
          닫기
        </div>
      </div>
    </div>
  );
}
export default OrderHistory;
